import { getTrackingKey } from '@/utils/api'

import API from './base'

class Profile extends API {
  getProfile = ({ checkoutId = '' } = {}) => {
    return this.fetcher({
      method: 'GET',
      trackingKey: this.uri.substring(1).replace('/', '_'),
      path: this.uri,
      data: { checkout_id: checkoutId },
    })
  }

  setLocale = (locale) => {
    return this.fetcher({
      path: this.uri + '/set-locale',
      trackingKey: getTrackingKey(this.uri, 'set-locale'),
      method: 'POST',
      data: { locale },
    })
  }
}

export default new Profile('/customers/profile')
